(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-cefit-video]').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      if (video.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && !Shopify.designMode) {
        video.muted = true;
        video.play().catch(() => {});
      }
    });
    const dialog = document.querySelector('#aroma-dialog');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    document.querySelectorAll('[data-aroma-open]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
    dialog.querySelectorAll('button').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      const b = dialog.getBoundingClientRect();
      if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
